import customAxios from "../index";

export const getPreneedProfileManagementDetails = () => {
    return customAxios({
        method: "GET",
        url: `/planner-dashboard/profile-management/planner-details`,
    });
};

export const updatePreneedProfileBasicDetails = (data: any) => {
    return customAxios({
        method: "PUT",
        url: "/planner-dashboard/profile-management/basic-details",
        data,
    });
};

export const addServiceableLocation = (data: any) => {
    return customAxios({
        method: "POST",
        url: "/planner-dashboard/profile-management/serviceable-location",
        data,
    });
};

export const deleteServiceableLocation = (serviceableLocationId: number) => {
    return customAxios({
        method: "DELETE",
        url: `/planner-dashboard/profile-management/serviceable-location/${serviceableLocationId}`,
    });
};

export const uploadPreneedMedia = (data: any) => {
    return customAxios({
        method: "POST",
        url: "/planner-dashboard/profile-management/upload-gallery-images",
        data,
    });
};

export const updateBankDetails = (data: any) => {
    return customAxios({
        method: "PUT",
        url: "/planner-dashboard/profile-management/bank-details",
        data,
    });
};

export const addLicenseDetails = (data: any) => {
    return customAxios({
        method: "POST",
        url: "/planner-dashboard/profile-management/add-licence-details",
        data,
    });
};

export const uploadPreneedDocument = (data: any) => {
    return customAxios({
        method: "POST",
        url: "/planner-dashboard/profile-management/upload-documents",
        data,
    });
};

export const updateBusinessAddress = (data: any) => {
    return customAxios({
        method: "PUT",
        url: "/planner-dashboard/profile-management/business-address",
        data,
    });
};

export const deleteLicenseDetails = (id: number) => {
    return customAxios({
        method: "DELETE",
        url: `/planner-dashboard/profile-management/delete-licence-details/${id}`,
    });
};

export const updateServicePackages = (data: any) => {
    return customAxios({
        method: "PUT",
        url: "/planner-dashboard/profile-management/service-packages",
        data,
    });
};

export const deleteGalleryImages = (id: number) => {
    return customAxios({
        method: "DELETE",
        url: `/planner-dashboard/profile-management/delete-gallery-images/${id}`,
    });
};